import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_ZONE_AC_PACKAGED_UNIT',
  CREATE: 'CREATE_ZONE_AC_PACKAGED_UNIT',
  EDIT: 'EDIT_ZONE_AC_PACKAGED_UNIT',
  DELETE: 'DELETE_ZONE_AC_PACKAGED_UNIT',
};

export const searchACPackagedUnitInZone = (pageSize, page, sorted, filtered, isPublic, zoneId) => {
  const zoneParams = zoneId === null ? { zone_id__is_null: true } : { zone_id: zoneId };
  return RestClient.request({
    method: 'get',
    url: Constants.API_ZONE_AC_PACKAGED_UNIT,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
      ...zoneParams,
    },
  });
};

export const listACPackagedUnitInZone = (pageSize, page, sorted, filtered, isPublic, zoneId) => {
  return {
    type: ACTION.LIST,
    payload: searchACPackagedUnitInZone(pageSize, page, sorted, filtered, isPublic, zoneId)
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const addACPackagedUnitToZone = (acPackagedUnitId, zoneId, quantity) => {
  const formData = new FormData();
  formData.set('air_conditioning_packaged_id', acPackagedUnitId);
  formData.set('zone_id', zoneId);
  formData.set('quantity', quantity);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_ZONE_AC_PACKAGED_UNIT,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editACPackagedUnitInZone = (id, quantity) => {
  const formData = new FormData();
  formData.set('quantity', quantity);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_ZONE_AC_PACKAGED_UNIT}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const removeACPackagedUnitFromZone = id => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_ZONE_AC_PACKAGED_UNIT}${id}/`,
    })
      .then(() => ({ id }))
      .catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/zone/zone_ac_packaged_unit_actions.js